import { createStore } from '../../../common/Store';
import { AlgorithmSourceFormDataType } from '../sources/schema/types';

export interface AlgorithmMappingsFormStoreData {
  algorithmSourcesBySourceType: Map<
    'DB' | 'DOD',
    AlgorithmSourceFormDataType[]
  >;
  algorithmSourcesById: Map<number, AlgorithmSourceFormDataType>;
  isDbSources: boolean;
}

export const AlgorithmMappingsFormStore =
  createStore<AlgorithmMappingsFormStoreData>();
